import apiService from '@sonifi/wb-core/services/api.service';
import {
  setForgotSubmitted,
  setUser,
} from '@sonifi/wb-user/store//userSlice';
import { createUserPermissions } from './permissions.service';

export const getUser = (userId) => async (dispatch) => {
  const url = `users/${userId}`;
  const res = await apiService.get(url);
  const permissions = await dispatch(createUserPermissions(res.data));
  const user = { ...res.data, permissionsList: permissions };
  dispatch(setUser({ user }));
  return user;
};

export const forgotPassword = (email) => async (dispatch) => {
  const url = 'users/password_reset_tokens';
  await apiService.post(url, { email });
  dispatch(setForgotSubmitted(true));
};
